import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2CommentOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em"><path d="m30 22-1.4 2H13.747L6 30.05V24c-2.206 0-4-1.794-4-4V4h24c2.205 0 4 1.794 4 4v12h-2V8c0-1.103-.897-2-2-2H4v14c0 1.103.897 2 2 2h2v3.95L13.06 22zM8 12h17v-2H8zm0 3v2h9.8l1.154-2z" /></svg>
);
